import { Form, Checkbox } from 'antd';
import PropTypes from 'prop-types';
import './secciones.scss';

const SeccionRepresentantes = ({ form }) => {
  return (
    <div>
      <Form form={form} layout="horizontal">
        <div className="container-datos">
          <Form.Item name="tipoAsociacionRep">
            <Checkbox
              className="check-campos"
              onChange={({ target }) => {
                form.setFieldsValue({ tipoAsociacionRep: target.checked });
              }}>
              Tipo de asociación
            </Checkbox>
          </Form.Item>
          <Form.Item name="sujetoObligadoRep">
            <Checkbox
              className="check-campos"
              onChange={({ target }) => {
                form.setFieldsValue({ sujetoObligadoRep: target.checked });
              }}>
              Sujeto Obligado
            </Checkbox>
          </Form.Item>
          <Form.Item name="escritoAcreditacionRep">
            <Checkbox
              className="check-campos"
              onChange={({ target }) => {
                form.setFieldsValue({ escritoAcreditacionRep: target.checked });
              }}>
              Escrito de acreditación
            </Checkbox>
          </Form.Item>
          <Form.Item name="primerApellidoRep">
            <Checkbox
              className="check-campos"
              onChange={({ target }) => {
                form.setFieldsValue({ primerApellidoRep: target.checked });
              }}>
              Primer apellido
            </Checkbox>
          </Form.Item>
          <Form.Item name="segundoApellidoRep">
            <Checkbox
              className="check-campos"
              onChange={({ target }) => {
                form.setFieldsValue({ segundoApellidoRep: target.checked });
              }}>
              Segundo apellido
            </Checkbox>
          </Form.Item>
          <Form.Item name="nombreRep">
            <Checkbox
              className="check-campos"
              onChange={({ target }) => {
                form.setFieldsValue({ nombreRep: target.checked });
              }}>
              Nombre(s)
            </Checkbox>
          </Form.Item>
          <Form.Item name="puestoRep">
            <Checkbox
              className="check-campos"
              onChange={({ target }) => {
                form.setFieldsValue({ puestoRep: target.checked });
              }}>
              Puesto
            </Checkbox>
          </Form.Item>
          <Form.Item name="claveElectorRep">
            <Checkbox
              className="check-campos"
              onChange={({ target }) => {
                form.setFieldsValue({ claveElectorRep: target.checked });
              }}>
              Clave de elector
            </Checkbox>
          </Form.Item>
          <Form.Item name="correoRep">
            <Checkbox
              className="check-campos"
              onChange={({ target }) => {
                form.setFieldsValue({ correoRep: target.checked });
              }}>
              Correo electrónico
            </Checkbox>
          </Form.Item>
          <Form.Item name="anversoRep">
            <Checkbox
              className="check-campos"
              onChange={({ target }) => {
                form.setFieldsValue({ anversoRep: target.checked });
              }}>
              Identificación anverso
            </Checkbox>
          </Form.Item>
          <Form.Item name="reversoRep">
            <Checkbox
              className="check-campos"
              onChange={({ target }) => {
                form.setFieldsValue({ reversoRep: target.checked });
              }}>
              Identificación reverso
            </Checkbox>
          </Form.Item>
          <Form.Item name="firmaRep">
            <Checkbox
              className="check-campos"
              onChange={({ target }) => {
                form.setFieldsValue({ firmaRep: target.checked });
              }}>
              Firma
            </Checkbox>
          </Form.Item>
        </div>
      </Form>
    </div>
  );
};

export default SeccionRepresentantes;

SeccionRepresentantes.propTypes = {
  form: PropTypes.shape({
    setFieldsValue: PropTypes.func,
    getFieldsValue: PropTypes.func
  }).isRequired
};
